"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
var _LoadableComponent = _interopRequireDefault(require("../../components/LoadableComponent"));
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 *  A react component to create Scroll Spy Navigation
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A Scroll Spy
 */
function ScrollSpyNav(props) {
  var extractedFields, componentParam;
  var [componentMounted, setComponentMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setComponentMounted(true);
  }, []);
  var ScrollContent = props => {
    if (props.IsContentDynamic.value) {
      if (!(0, _lodash.isEmpty)(props.DynamicContent)) {
        return /*#__PURE__*/_react.default.createElement(ContentDynamic, props);
      } else return null;
    } else return /*#__PURE__*/_react.default.createElement(ContentStatic, props);
  };
  var ContentDynamic = props => {
    var lstItems = [];
    for (var i = 0; i < ((_props$DynamicContent = props.DynamicContent) === null || _props$DynamicContent === void 0 ? void 0 : _props$DynamicContent.length); i++) {
      var _props$DynamicContent, _props$DynamicContent2;
      var comp = /*#__PURE__*/_react.default.createElement(_LoadableComponent.default, {
        name: (_props$DynamicContent2 = props.DynamicContent[i].fields.ComponentName) === null || _props$DynamicContent2 === void 0 ? void 0 : _props$DynamicContent2.value,
        rendering: props.DynamicContent[i],
        params: componentParam,
        parentComponent: "scrollspy"
      });
      lstItems.push(comp);
    }
    return lstItems;
  };
  var ContentHeading = props => {
    var _props$StyleHeading$f;
    return /*#__PURE__*/_react.default.createElement(_LoadableComponent.default, {
      name: (_props$StyleHeading$f = props.StyleHeading.fields.ComponentName) === null || _props$StyleHeading$f === void 0 ? void 0 : _props$StyleHeading$f.value,
      rendering: props.StyleHeading,
      params: componentParam,
      parentComponent: "tab"
    });
  };
  var ContentStatic = props => {
    return /*#__PURE__*/_react.default.createElement("div", null, (0, _richTextField.parseHTML)(props.StaticContent));
  };
  if (props.rendering.fields && componentMounted === true) {
    extractedFields = (0, _utils.extractFieldsFn)(props);
    componentParam = props.params;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
      className: "scrollspy-container"
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.ScrollSpy, {
      contentClass: "col-12 col-md-9",
      navClass: "col-3",
      behavior: "smooth",
      placement: "consumer"
    }, extractedFields.Content.map(scrollList => {
      var _scrollList$fields$Ti;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: scrollList.id,
        name: (_scrollList$fields$Ti = scrollList.fields.Title) === null || _scrollList$fields$Ti === void 0 ? void 0 : _scrollList$fields$Ti.value,
        "data-id": scrollList.id
      }, scrollList.fields.displayTitle.value && /*#__PURE__*/_react.default.createElement("a", {
        id: scrollList.id
      }, (0, _titleHeadTag.headTagTitle)(scrollList.fields.Title, '', scrollList.fields.TitleSize.value)), scrollList.fields.IsContentDynamic.value === false && scrollList.fields.AddStyledHeading.value && /*#__PURE__*/_react.default.createElement(ContentHeading, scrollList.fields), /*#__PURE__*/_react.default.createElement(ScrollContent, scrollList.fields));
    })));
  } else return null;
}
var _default = exports.default = ScrollSpyNav;